import Button from 'components/shared/Button/Button';
import Typography from 'components/shared/Typography/Typography';

const PaymentEntryHeader = ({ config, isNew, goBack, canGoBack, isDisabled = false }) => (
  <div className="flex flex-wrap items-center gap-2">
    {isNew && canGoBack && (
      <Button
        icon="arrow-left-linear"
        variant="link"
        color="neutral"
        isDisabled={isDisabled}
        onClick={goBack}
        aria-label="Go back"
      />
    )}
    <Typography
      variant="label"
      color={isNew ? 'neutral-600' : 'neutral-800'}
      weight="medium"
      size="medium">
      {config.title}
    </Typography>
    {isNew && canGoBack && (
      <Typography variant="label" color="neutral-800" weight="medium" size="medium">
        / {config.newTitle}
      </Typography>
    )}
  </div>
);

export default PaymentEntryHeader;
